import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";

export default function NewsTicker() {
  const newsList = videos
    .filter((v) => v.category === "film-news")
    .slice(0, 7);
  const loopList = [...newsList, ...newsList];

  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden flex items-stretch">
        <div className="flex items-center gap-2 px-4 md:px-5 bg-primary-500 text-background-50 shrink-0">
          <i className="ri-volume-up-fill text-lg" />
          <span className="text-sm font-medium whitespace-nowrap hidden sm:inline">
            最新影视资讯
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex items-center gap-8 py-4 animate-ticker w-max">
            {loopList.map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/detail/${item.id}`}
                className="flex items-center gap-2 text-sm text-foreground-800 hover:text-primary-700 whitespace-nowrap cursor-pointer"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
                {item.title}
                <span className="text-xs text-foreground-400">
                  {item.publishDate}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}